export default "__VITE_ASSET__DMhqKC6a__"